import React from 'react';
import { RouteProp } from '@react-navigation/native';
import { CareTeamActionButtonFrom } from '../../../../shared/CareTeamForm';
import { ResourcesTabParamList, useGoBack, useProfilesTabNavigation } from '../../../../../utils/appNavigationNames';
import { useConfirmBackNavigationOnDirtyForm } from '../../../../shared/FormExitValidation';
import useOrganizationCareTeamMembers from '../../../../../hooks/api/useOrganizationCareTeamMembers';
import { useOrganizationId } from '../../../../../hooks/api/useOrganization';

export type AddCareTeamMemberScreenOwnProps = {};

export type AddCareTeamMemberScreenNavigatorProps = {
    route: RouteProp<ResourcesTabParamList, 'add-care-team-member'>;
};

export type AddCareTeamMemberScreenProps = AddCareTeamMemberScreenOwnProps & AddCareTeamMemberScreenNavigatorProps;

const AddCareTeamMemberScreen: React.FC<AddCareTeamMemberScreenProps> = () => {
    const organizationId = useOrganizationId();
    const goBack = useGoBack();
    const navigator = useProfilesTabNavigation();
    useConfirmBackNavigationOnDirtyForm(navigator);
    const { createCareTeamMember, isCreatingCareTeamMember } = useOrganizationCareTeamMembers({
        onCreateCareTeamMember: goBack,
    });
    return (
        <CareTeamActionButtonFrom
            onSubmit={(careTeamMember) =>
                createCareTeamMember({
                    ...careTeamMember,
                })
            }
            isSubmitting={isCreatingCareTeamMember}
            source={{
                source: 'organization',
                organizationId,
            }}
            shouldRecordAddCareTeamMember
        />
    );
};

export default React.memo(AddCareTeamMemberScreen);
